import { createReducer, on } from '@ngrx/store';

import { PendingRequest, ReportParameter } from '#types/report';

import { ReportActions } from '@report/state';

export interface ReportState {
  requestId: string;
  reportName: string;
  format: string;
  filename: string;
  hasNoParameters: boolean;
  parameters: ReportParameter[];
  pendingRequests: PendingRequest[];
}

export const initialState: ReportState = {
  requestId: null,
  reportName: null,
  format: null,
  filename: null,
  hasNoParameters: false,
  parameters: [],
  pendingRequests: [],
};

export const reducer = createReducer<ReportState>(
  initialState,

  //
  // report / get parameters
  //

  on(
    ReportActions.RequestReportGetParameters,
    (state, action): ReportState => ({
      ...state,
      requestId: null,
      reportName: action.reportName,
      format: null,
      hasNoParameters: false,
      parameters: [],
    })
  ),

  on(
    ReportActions.RequestReportGetParametersSuccess,
    (state, action): ReportState => ({
      ...state,
      requestId: action.data.requestId,
      hasNoParameters: action.data.message === 'NO-PARAMS' ? true : false,
      parameters: [...action.data.params],
    })
  ),

  on(
    ReportActions.RequestReportGetParametersFailure,
    (state, _action): ReportState => ({
      ...state,
      requestId: null,
      reportName: null,
      format: null,
      hasNoParameters: false,
      parameters: [],
    })
  ),

  //
  // report / get parameters refresh
  //

  on(
    ReportActions.RequestReportGetParametersRefresh,
    (state): ReportState => ({
      ...state,
      requestId: null,
    })
  ),

  on(
    ReportActions.RequestReportGetParametersRefreshSuccess,
    (state, action): ReportState => ({
      ...state,
      requestId: action.data.requestId,
    })
  ),

  on(
    ReportActions.RequestReportGetParametersRefreshFailure,
    (state, _action): ReportState => ({
      ...state,
      requestId: null,
    })
  ),

  //
  // report / clear parameters
  //

  on(
    ReportActions.RequestReportClearParameters,
    (state): ReportState => ({
      ...state,
      format: null,
      hasNoParameters: false,
      parameters: [],
    })
  ),

  //
  // report / set parameters
  //

  on(
    ReportActions.RequestReportSetParameters,
    (state, action): ReportState => ({
      ...state,
      format: null,
      parameters: [...action.parameters],
    })
  ),

  on(
    ReportActions.RequestReportSetParametersSuccess,
    (state, action): ReportState => ({
      ...state,
      format: action.format,
    })
  ),

  //
  // report / run report
  //

  on(
    ReportActions.RequestReportRunReport,
    (state): ReportState => ({
      ...state,
      filename: null,
    })
  ),

  on(
    ReportActions.RequestReportRunReportSuccess,
    (state, action): ReportState => ({
      ...state,
      filename: action.data.filename,
    })
  ),

  on(
    ReportActions.RequestReportRunReportFailure,
    (state, _action): ReportState => ({
      ...state,
      filename: null,
    })
  ),

  //
  // pending report requests
  //

  on(
    ReportActions.PendingReportAdd,
    (state, action): ReportState => ({
      ...state,
      pendingRequests: [...state.pendingRequests, { requestId: action.requestId, filename: action.filename, format: action.format }],
    })
  ),

  on(ReportActions.PendingReportRemove, (state, action): ReportState => {
    const pendingRequests: PendingRequest[] = [];

    for (const request of [...state.pendingRequests]) {
      if (request.requestId !== action.requestId) {
        pendingRequests.push(request);
      }
    }

    return {
      ...state,
      pendingRequests: [...pendingRequests],
    };
  }),

  on(
    ReportActions.PendingReportClear,
    (state, _action): ReportState => ({
      ...state,
      pendingRequests: [],
    })
  )
);
